import { render, staticRenderFns } from "./GradingTable.vue?vue&type=template&id=3f174476&"
import script from "./GradingTable.vue?vue&type=script&lang=js&"
export * from "./GradingTable.vue?vue&type=script&lang=js&"
import style0 from "./GradingTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports